import { Buffer } from 'buffer';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import process from 'process';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from "./App";
import './App.css';
import './index.css';


const isProd = import.meta.env.PROD || import.meta.env.VITE_ENV === 'prod' || import.meta.env.VITE_ENV === 'production' || (!import.meta.env.VITE_ENV && window.location.hostname.startsWith('https://'));

declare global {
  interface Window {
    Buffer: typeof Buffer;
    process: typeof process;
  }
}


window.Buffer = Buffer;
window.process = process;

const component = isProd && posthog.__loaded ?
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider> : <App />;


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {component}
  </StrictMode>,
)